import type { IChat } from './interfaces/chat.interface';
import type { TChatMessageRole } from './interfaces/chat-message.interface';

/** The summary generation lock times out and can be retried after 60s. */
const SUMMARY_GENERATE_TIMEOUT = 60_000;

/** The assistant message generation lock times out and can be retried after 2 minutes. */
const RESPONSE_GENERATE_TIMEOUT = 120_000;

const isInProgress = (startedAt: string | number | Date | undefined, timeout: number) =>
  startedAt && new Date(startedAt) > new Date(Date.now() - timeout);

/** Returns true if the summary is being generated. */
export const summaryIsInProgress = (chat: Pick<IChat<object>, 'summaryStartedAt'>) =>
  isInProgress(chat.summaryStartedAt, SUMMARY_GENERATE_TIMEOUT);

/** Returns true if a response is being generated. */
export const responseIsInProgress = (chat: Pick<IChat<object>, 'responseStartedAt'>) =>
  isInProgress(chat.responseStartedAt, RESPONSE_GENERATE_TIMEOUT);

/** Returns true if the latest chat message was by the given role. */
export const latestMessageRoleIs = (
  chat: Pick<IChat<object>, 'messages'>,
  role: TChatMessageRole,
) => chat.messages.at(-1)?.role === role;
